import { CoreModule } from '../domain/core/core.module';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { pageTransitionAnimations, SharedModule } from '@shared';
import { BusinessLayerModule } from '@domain/business-layer';
import { AppRoutingModule } from './app-routing.module';
import { SearchState } from '@domain/search';
import { ErrorHandlerIntercetor } from '@api/http';
import { AuthInterceptorService } from '@api/authentication';
import { RequestsStatusInterceptorService } from '../api/external-transfer/interceptors/requests-status.interceptor';
import { SecureStorage } from '@awesome-cordova-plugins/secure-storage/ngx';

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		IonicModule.forRoot({
			navAnimation: pageTransitionAnimations,
			mode: 'ios',
			scrollPadding: false,
			scrollAssist: false,
			innerHTMLTemplatesEnabled: true
		}),
		CoreModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: (http) => new TranslateHttpLoader(http),
				deps: [HttpClient]
			}
		}),
		HttpClientModule,
		BusinessLayerModule,
		AppRoutingModule,
		SharedModule
	],
	providers: [
		SecureStorage,
		StatusBar,
		SplashScreen,
		{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
		SearchState,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ErrorHandlerIntercetor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptorService,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: RequestsStatusInterceptorService,
			multi: true
		}
	],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
